// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'prescription';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M8.752 16.867H2.343a1.21 1.21 0 0 1-1.21-1.21V2.343a1.21 1.21 0 0 1 1.21-1.21h8.473l6.051 6.052v1.667' />
    <path d='M10.816 6.58V1.132l6.051 6.052h-5.446a.605.605 0 0 1-.605-.606zm-7.202 7.931h2.22m-2.22-2.178H7.29m6.353-1.093a1.943 1.943 0 0 1 2.747 2.747l-2.341 2.34a1.943 1.943 0 0 1-2.763-2.73zm-1.061 1.061 2.746 2.747M3.614 3.317h1.64a1.383 1.383 0 1 1 0 2.766h-1.64m-.063-2.766v5.269m1.302-2.488 3.57 3.57m-.001-2.866L5.557 9.667' />
  </g>
);

export const viewBox = '0 0 18 18';
